import React from 'react'
import './footer.scss'
import logo from "../../assets/images/obliqua.png";


const Footer = () => {
  return (
    <footer>
        <div className='footer-left'>
            <img src={logo} alt="logo" />
        </div>
        <div className='footer-right'>
            <button>Our Capabilities Deck</button>
        </div>
        <p>© 2025 All rights reserved</p>
    </footer>
  )
}

export default Footer